<template>
  <div class="describe-message props-group">
    <p>描述信息</p>
    <el-form-item label="一星说明">
      <el-input v-model="component.properties.message.oneMessage" placeholder="请输入说明"></el-input>
    </el-form-item>
    <el-form-item label="二星说明">
      <el-input v-model="component.properties.message.twoMessage" placeholder="请输入说明"></el-input>
    </el-form-item>
    <el-form-item label="三星说明">
      <el-input v-model="component.properties.message.threeMessage" placeholder="请输入说明"></el-input>
    </el-form-item>
    <el-form-item label="四星说明">
      <el-input v-model="component.properties.message.fourMessage" placeholder="请输入说明"></el-input>
    </el-form-item>
    <el-form-item label="五星说明">
      <el-input v-model="component.properties.message.fiveMessage" placeholder="请输入说明"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-describe-message',
  props: ['component']
}
</script>
<style lang="scss">
.describe-message.props-group {
  border-top: 1px solid #C2C3C4;
  margin: 0 -20px;
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/describe-message.vue